export const GLOBAL_SEARCH_DEBOUNCE_MS = 500;

export const GLOBAL_SEARCH_MODULE_LIST_CLASS_NAME = {
  compact: 'max-h-40',
  expanded: 'max-h-80',
} as const;

export const GLOBAL_SEARCH_CONTAINER_CLASS_NAME =
  'relative ml-5 w-full max-w-[500px]';

export const GLOBAL_SEARCH_DROPDOWN_CLASS_NAME =
  'absolute top-full left-0 z-50 mt-1 w-full min-w-[320px] rounded-md border bg-white shadow-md';
